// extracted by mini-css-extract-plugin
export default {"formHeading":"LI-z","form":"MI-z","submitBtn":"NI-z","disabled":"OI-z","input":"PI-z","error":"QI-z","submitMsg":"RI-z","signIn":"SI-z"};